import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  IconButton,
  Typography,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import TextInput from "../InputComponents/TextInput";
import CommonButton from "../InputComponents/CommonButton";
import { axiosAPI } from "../AxiosComponents/Axios";
import {
  errorNotify,
  infoNotify,
  successNotify,
} from "../../Components/ToastComponent/ToastNotification";

const ChangePasswordModal = ({ open, onClose, userType = "Client" }) => {
  const [showPassword, setShowPassword] = useState(false);
  const [btndisable, setbtndisable] = useState(false);
  const [passwords, setPasswords] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  // Handle input change
  const handleChange = (field, value) => {
    setPasswords({ ...passwords, [field]: value });
  };

  // Handle form submission
  const handleSubmit = () => {
    if (!passwords.currentPassword.trim() || !passwords.newPassword.trim()) {
      infoNotify("Current Password and New Password cannot be empty!");
    } else if (passwords.newPassword !== passwords.confirmPassword) {
      infoNotify("New Password and Confirm Password do not match!");
    } else {
      setbtndisable(true);
      axiosAPI
        ?.post(`/${userType}/change-password`, {
          oldPassword: passwords?.currentPassword,
          newPassword: passwords?.newPassword,
        })
        .then((res) => {
          setbtndisable(false);

          if (res?.data?.success) {
            successNotify(res?.data?.message);
            setPasswords({
              currentPassword: "",
              newPassword: "",
              confirmPassword: "",
            });
            onClose(); // Close modal after submission
          }
        })
        .catch((err) => {
          setbtndisable(false);
          errorNotify(`Something went wrong`);
          errorNotify(err?.response?.data?.message);
        });
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle
        sx={{
          textAlign: "center",
          fontWeight: "bold",
          color: "#0977BC",
          mt: 3,
          mb: 2,
          fontFamily: "Geist, sans-serif",
        }}
      >
        Change Password
      </DialogTitle>

      <DialogContent>
        {["currentPassword", "newPassword", "confirmPassword"].map(
          (field, index) => {
            const labelMap = {
              currentPassword: "Current Password",
              newPassword: "New Password",
              confirmPassword: "Confirm New Password",
            };

            return (
              <Box key={field} sx={{ mb: 1 }}>
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontWeight: 500,
                    mb: 1,
                    fontFamily: "Geist, sans-serif",
                  }}
                >
                  {labelMap[field]}
                </Typography>
                <TextInput
                  placeholder={labelMap[field]}
                  type={showPassword ? "text" : "password"}
                  value={passwords[field]}
                  onChange={(e) => handleChange(field, e.target.value)}
                  endAdornment={
                    <IconButton
                      onClick={() => setShowPassword(!showPassword)}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  }
                />
              </Box>
            );
          }
        )}
      </DialogContent>

      <DialogActions sx={{ mt: 3, mb: 3, mr: 3 }}>
        <Box sx={{ display: "flex", gap: 2 }}>
          <CommonButton
            variant="outlined"
            customColor="#B0BEC5"
            onClick={onClose}
          >
            Cancel
          </CommonButton>
          <CommonButton
            variant="contained"
            customColor="#007BFF"
            onClick={handleSubmit}
            disabled={btndisable}
          >
            Save
          </CommonButton>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default ChangePasswordModal;
